import Link from "next/link";
import React, { useState, useEffect, useId } from "react";
import {openAccountSidebar, updateAuthCookie } from "@/redux/actions/loggedInUser";
import {
  createAccount,
  createAccessToken,
  createUserLogin,
  customerLoginData,
  checkMigratedCustomer,
  checkUserLogin,
  extractUserCauseFromTags,
  updateUserWishlistID,
  performKlaviyoMerge,
} from "@/helpers/userHelpers";
import Image from "next/image";
import { setCookie, getCookie ,deleteCookie} from "cookies-next";
import styles from "components/Header/Account/Account.module.scss";
import Srcset from "@/components/common/Srcset";
import { useRouter } from "next/compat/router";
import { useDispatch, useSelector } from "react-redux";
import { loggedInUser } from "@/redux/actions/loggedInUser";
import { errorMessages, generalConstants } from "@/utils/constants";
import { KlaviyoUserRegister } from "@/components/common/Klaviyo";
import { setCustomer } from "@/components/common/Nosto";
import { crossDeviceTracking, emailTracking } from "../common/Tracking";
import { updateUserCheckoutID } from "@/helpers/userHelpers";
import CryptoJS from  'crypto-js';
import { checkIfEmail, validatePassword } from '@/helpers/generalHelper';
import {redirectToUrl} from "@/helpers/generalHelper";
import { saveUserCharityLocalStorage, updateCartWhenCharityUpdates, updateUserCause } from "@/helpers/charityHelper";
import { setUserCause } from "@/redux/actions/generalAction";
import { reportError } from "@/helpers/errorHelper";
import { updateCart } from "@/redux/actions/addToCartAction";
import { isMenuVisible} from "@/redux/actions/headerAction";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import { showPwaLoader, WelcomeJourneyState, welcomeStep } from "@/redux/actions/pwaAction";
import InputField from "@/components/common/CommonInputComponent";

export default function PageWithJSbasedForm(props) {
  const [firstName, setFirstName] = useState("");
  const [migratedApiCheck, setMigratedApiCheck] = useState(false);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [validEmail, setValidEmail] = useState();
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [passwordType, changePasswordType] = useState(true);
  const [alreadyAccount, setAlreadyAccount] = useState(false);
  const [alreadyAccountMsg, setAlreadyAccountMsg] = useState(errorMessages.authentication.signInInsted);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState(false);
  const [firstErrorMessage, setFirstErrorMessage] = useState(false);
  const [lastErrorMessage, setLastErrorMessage] = useState(false);
  const [validPassword, setValidPassword] = useState();
  const [loading, setLoading] = useState(false);
  const default_cause = useSelector((state) => state.general.default_cause);
  const user_cause = useSelector((state) => state.general.user_cause);
  const cause_list = useSelector((state) => state.general.cause_list);
  const checkPwaGuest = useSelector((state) => state.pwa.is_guest);
  const router = useRouter();
  const dispatch = useDispatch();
  const acceptsMarketing = useId();
  var rewards_redirect = getCookie("redirect_path");
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const isUserloggedIn = useSelector(
    (state) => state.loginUser.userLoggedIn
  )
  //To track if sign in done through wishlist
  let wishlist_cookie = getCookie("show_wishlist");
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const wc_journey_step = useSelector((state) => state.pwa.welcome_journey.currentStepNo);
  useEffect(() => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setValidEmail("");
    setEmailErrorMessage("");
    changePasswordType(true);
    setAlreadyAccount(false);
    setPasswordErrorMessage(false);
    setFirstErrorMessage(false);
    setLastErrorMessage(false);
    setValidPassword();
    setLoading(false);
  }, [props.accountSidebarOpen]);
  let { setSignInTab, setShowResetPassword, setAutoFillEmail, setEmailAtActivateAccount } = props;


  //Allert For Wrong Email format
  async function handleEmailFormat(event) {
    let emailVal =
      event.target.email && event.target.email.value
        ? event.target.email.value
        : event.target.value;

    if (emailVal) {
      var validateEmail = checkIfEmail(emailVal);
      setValidEmail(validateEmail);
      if (!validateEmail) {
        // alert("Please enter a valid email address")
        setEmailErrorMessage(errorMessages.authentication.invalidEmail);
      } else {
        setEmailErrorMessage(null);
        if(!migratedApiCheck) {
          const response1 = await checkMigratedCustomer(emailVal);
          setMigratedApiCheck(true);
          props.setSubmittedEmail(emailVal);
          if(response1) {
            props.setMigratedUserState(response1);
            setShowResetPassword("activateAccountTab"); 
            setEmailAtActivateAccount(true);
          }
        }
      }
      if (email) {
      } else {
        setEmailErrorMessage(null);
      }
    } else {
      setEmailErrorMessage(errorMessages.authentication.emptyEmail);
    }
  }

  function handleFirstName(event) {
    let firstName =
      event.target.firstName && event.target.firstName.value
        ? event.target.firstName.value
        : event.target.value;

    if (firstName) {
      setFirstErrorMessage(null);
    } else {
      setFirstErrorMessage(errorMessages.authentication.emptyFirstName);
    }
  }

  function handleLastName(event) {
    let lastName =
      event.target.lastName && event.target.lastName.value
        ? event.target.lastName.value
        : event.target.value;
    if (lastName) {
      setLastErrorMessage(null);
    } else {
      setLastErrorMessage(errorMessages.authentication.emptyLastName);
    }
  }

  function handlePasswordFormat(event) {
    let passwordVal =
      event.target.password && event.target.password.value
        ? event.target.password.value
        : event.target.value;
    if (passwordVal) {
      var validateEmail = validatePassword(passwordVal);
      setValidPassword(validateEmail);
      if (!validateEmail) {
        // alert("Please enter a valid email address")
        setPasswordErrorMessage(true);
      } else {
        setPasswordErrorMessage(false);
      }
      if (password) {
      } else {
        setPasswordErrorMessage(false);
      }
    } else {
      setPasswordErrorMessage(true);
    }
  }

  //Check All fields are filled or not
  function handleChange(event) {
    if (event.target.name == "firstName") {
      setFirstName(event.target.value);
    }
    if (event.target.name == "lastName") {
      setLastName(event.target.value);
    }
    if (event.target.name == "email") {
      setEmail(event.target.value);
      setMigratedApiCheck(false);
    }
    if (event.target.name == "password") {
      setPassword(event.target.value);
    }
  }

  const handleBlurOut = (target, placeholderText) => {
    if (target) {
      target.placeholder = placeholderText;
    }
  };

  const togglePasswordVisibility = () => {
    changePasswordType(!passwordType);
  };

  // initialize user cause
  const validateAccessToken = async (token) => {
    let user_data = await checkUserLogin(token);
    if (user_data && user_data.userLoggedIn) {
      dispatch(loggedInUser(user_data));

      //This code get the user's cause from the tags and saves it in the local storage
      let causeInUrl = false;
      if(typeof window !== "undefined"){
        if(window.location.search.includes("cause")) {
          causeInUrl = true;
        }
      }
      if(user_data?.userData?.tags && !causeInUrl){
        let cause = await extractUserCauseFromTags(user_data.userData.tags)
        if(cause.length > 0){
          saveUserCharityLocalStorage(cause[0])
          dispatch(setUserCause(cause[0]))
        }
        else {
          // Update user cause in shopify when creating new account
          let causeToBeAdded = null;
          if(user_cause) causeToBeAdded = user_cause;
          else if(default_cause) causeToBeAdded = default_cause;
          try {
            causeToBeAdded = JSON.parse(causeToBeAdded);
          }
          catch(error) {
            reportError("Cause string format error");
            reportError(error);
          }
          if(causeToBeAdded) {
            if (cause_list) {
              const cause = cause_list.find(
                (cause) => cause.short_code === causeToBeAdded
              );
              if (cause) {
                const request = { cause: causeToBeAdded }
                console.log('updateUserCause createAccount=====')
                updateUserCause(request);
                //Update cause realted custom attribute for cart line items
                updateCartWhenCharityUpdates(causeToBeAdded,cause_list);
                var updatedCartList = JSON.parse(sessionStorage.getItem("cart_list"));
                dispatch(updateCart(updatedCartList));
                dispatch(setUserCause(causeToBeAdded));
              }
            }
          }
        }
      }

    } else {
      dispatch(loggedInUser({}));
      // setUserName("");
    }
    return user_data;
  };

  //OS-5049 the klaviyo actions are separated in this function to execute after 2 seconds of delay
  const performKlaviyoAction = async (userData,token_data) => {
    try {
      if(localStorage.getItem('klaviyo_external_id') && userData?.customer?.email) {
        await performKlaviyoMerge(userData?.customer?.email,localStorage.getItem('klaviyo_external_id'));        
      }  
            
    }
    catch(error) {
      reportError("klaviyo profile merge failed in create account");
      reportError(error);
    }
    window?.ReactNativeWebView?.postMessage(JSON.stringify({customerAccessToken:token_data.customerAccessTokenCreate}))

  }

  // Handles the submit event on form submit.
  const handleSubmit = async (event) => {
    // Stop the form from submitting and refreshing the page.
    event.preventDefault();
    handleEmailFormat(event);
    handlePasswordFormat(event);
    handleFirstName(event);
    handleLastName(event);
    if (
      firstName &&
      lastName &&
      email &&
      password &&
      validEmail &&
      validPassword &&
      !alreadyAccount
    ) {
      // Get data from the form.
      const data = {
        firstName: event.target.firstName.value,
        lastName: event.target.lastName.value,
        email: event.target.email.value,
        password: event.target.password.value,
        acceptsMarketing: document.querySelector("input[name=acceptsMarketing]")
          .checked,
      };
      setLoading(true);
      const response = await createAccount(data);
      KlaviyoUserRegister(response);
      setCustomer(response)
      setCookie("user_email_address", "");
      if (response && response.status === 406) {
        setAlreadyAccount(true);
        setAlreadyAccountMsg(
          "This email is already registered, would you like to sign in instead?"
        );
        setCookie("user_email_address", event.target.email.value);
        setLoading(false);
        return;
      }
      if (response && response.status === 407) {
        setShowResetPassword("activateAccount")
        setCookie("user_email_address", event.target.email.value);
        setLoading(false);
        return;
      }
      if (response && response.customer && response.customer.id) {
        const { asPath } = router;
        emailTracking('Account','Registration',response,asPath);
        //to set the cookies to login the user
        const token_data = await createAccessToken({
          email: event.target.email.value,
          password: event.target.password.value,
        });
        if (
          token_data &&
          token_data.customerAccessTokenCreate &&
          token_data.customerAccessTokenCreate.customerAccessToken
        ) {
          //FETCH USER DATA FROM SHOPIFY USING ACCESS TOKEN
          const userData = await customerLoginData({
            token:
              token_data.customerAccessTokenCreate.customerAccessToken
                .accessToken,
          });
          let expiry = false;
          await createUserLogin(
            token_data.customerAccessTokenCreate,
            userData,
            expiry
          );
          localStorage.setItem('klaviyo_external_profile_id','');
          deleteCookie('klaviyo_profile_identified')
          if(typeof klaviyo !== 'undefined' && klaviyo){
              klaviyo.identify({'email' : event.target.email.value});
              setCookie('klaviyo_profile_identified', "true")
          } 
          
          dispatch(loggedInUser(true));
          dispatch(isMenuVisible(false));
          //OS-5049 #delay added before calling klaviyo action items
          setTimeout(() => {
            performKlaviyoAction(userData,token_data)
          }, 2000);

          /* START: OS-2078 - Retain user cart */
          let checkoutId;
          // let checkoutId = getCookie("checkoutId");
          checkoutId = localStorage.getItem("pwacheckoutId")
          if (
            typeof checkoutId !== "undefined" &&
            checkoutId != "" &&
            token_data?.customerAccessTokenCreate?.customerAccessToken
              ?.accessToken
          ) {
            await updateUserCheckoutID({
              checkout_id: checkoutId,
              customerAccessToken:
                token_data.customerAccessTokenCreate.customerAccessToken
                  .accessToken,
            });
          }
          /* END: OS-2078 - Retain user cart */
          //  wishlisht sync
          //  every time when user creates an account==> wishlist id should create and store in shopify
          let wishlistHashId= localStorage.getItem("wishlistHash")
          if(typeof checkoutId !== "undefined" &&
          checkoutId != "" &&
          token_data?.customerAccessTokenCreate?.customerAccessToken
            ?.accessToken) {
              //  function to push wishlist id of user into shopify
              await updateUserWishlistID({
                wishlist_id: wishlistHashId,
                customerAccessToken:
                token_data.customerAccessTokenCreate.customerAccessToken
                .accessToken,
              })
            }

            //this fucntion is used to show the wishlist drawer only if user is clicking on wishlist sign in or create account link
            if(getCookie('show_wishlist')){
              setTimeout(() => {
                dispatch(openWishlistSidebar(true))
              }, 5000);
              deleteCookie("show_wishlist");
              if (router.asPath.includes("rewards")||router.asPath==("/")) {
                setCookie('show_wishlist_reload',true)
              }    
            }
            if (isPWA) {
              if (wc_journey_step == 3 && userData) {
                dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: true, currentStepNo: 4 }));
              }
              // window?.ReactNativeWebView?.postMessage(JSON.stringify({message: "Create account started"}));
            }
        } else {
          dispatch(loggedInUser(false));
          // setCookie("userdataToken", null);
        }
        
        if (rewards_redirect) {
          //Redirect to your bag page when logged in from mini cart
          deleteCookie(rewards_redirect);      
          window.location.assign("/your-bag")
        }
        //Redirect to particular path if redirect_url is present
        else if(router.query.redirect_url){
          redirectToUrl(router.query.redirect_url);
        }else{
          if (getCookie("userdataToken")) {
            let cookie_data = JSON.parse(getCookie("userdataToken"));
            // track user ids in GA4
            crossDeviceTracking(cookie_data.accessToken);
            // syncing user cause
            validateAccessToken(cookie_data.accessToken);
            dispatch(updateAuthCookie(cookie_data))
          }
          dispatch(openAccountSidebar(false))
          //SUP-2733 : If page path is /rewards then reload on register
          if(isPWA && wc_journey_step !== 6) {
            dispatch(welcomeStep(true))
          } else {
            if (router.asPath.includes("rewards")||router.asPath==("/")) {
              window.location.reload();
              if (isUserloggedIn) {
                if (typeof yotpoWidgetsContainer != "undefined" && typeof yotpoWidgetsContainer != undefined) {
                  yotpoWidgetsContainer.initWidgets();
                }
              }
            }
          }
        }
      }
      setLoading(false);
    }
  };
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);
  const handleAsGuest = () => {
    dispatch(openAccountSidebar(false));
    dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: true,currentStepNo:5 }));
  };
  return (
    // We pass the event to the handleSubmit() function on submit.
    <form onSubmit={handleSubmit} className={`${styles.form_wrap}`}>
      <div className={`${isPWA && checkPwaGuest && wc_journey_step !== 6? styles.pwa_input_form:""}`}>
      <InputField
        type="firstName"
        id="firstName"
        name="firstName"
        label="First name*"
        placeholder=" "
        autoComplete="first-name"
        ariaLabel="your-first-name"
        className="normal-md small-xs normal-sm"
        errorMessage={firstErrorMessage}
        onFocus={(e) => (e.currentTarget.placeholder = '')}
        onChange={handleChange}
        onBlur={(e) => {
          handleFirstName(e);
        }}
        />
      <InputField
          type="lastName"
          id="lastName"
          name="lastName"
          label="Last name*"
          placeholder=" "
          autoComplete="family-name"
          ariaLabel="your-last-name"
          className="normal-md small-xs normal-sm"
          errorMessage={lastErrorMessage}
          onFocus={(e) => (e.currentTarget.placeholder = '')}
          onChange={handleChange}
          onBlur={(e) => {
            handleLastName(e);
          }}
        />
      <InputField
          type="text"
          id="email"
          name="email"
          label="Email address*"
          placeholder=" "
          autoComplete="email"
          ariaLabel="your-email"
          className="normal-md small-xs normal-sm auto-createAcc-email"
          errorMessage={emailErrorMessage}
          onFocus={(e) => (e.currentTarget.placeholder = '')}
          onChange={handleChange}
          onBlur={(e) => {
            handleEmailFormat(e);
          }}
          alreadyAccount={alreadyAccount}
          alreadyAccountMsg={alreadyAccountMsg}
          isEmail={true}
        />
      <InputField
          type={passwordType ? 'password' : 'text'}
          id="password"
          name="password"
          label="Password*"
          placeholder=" "
          autoComplete="password"
          ariaLabel="your-password"
          className="normal-md small-xs normal-sm auto-createAcc-pwd"
          errorMessage={passwordErrorMessage}
          onFocus={(e) => (e.currentTarget.placeholder = '')}
          onChange={handleChange}
          onBlur={(e) => {
            handlePasswordFormat(e);
          }}
          alreadyAccount={alreadyAccount}
          alreadyAccountMsg={alreadyAccountMsg}
          isPassword={true}
          togglePasswordVisibility={togglePasswordVisibility}
          isPasswordVisible={!passwordType}
          setAutoFillEmail={setAutoFillEmail}
          setSignInTab={setSignInTab}
          setShowResetPassword={setShowResetPassword}
        />
      <div className={`${styles.form_item} ${styles.marketing_field}`}>
        <div className="custom-checkbox custom-checkbox-sm ca_chkbox_mob">
          <input
            id={acceptsMarketing}
            name="acceptsMarketing"
            type="checkbox"
            className="ga-marketing-msg"
          />
          <label
            className="pwa-link-tag xx-small-xs small-sm x-small-md"
            htmlFor={acceptsMarketing}
          >
            I would like to receive marketing communications. Further
            information is available in our{" "}
            <Link tabIndex={0} className="pwa-link-tag xx-small-xs small-sm x-small-md" onClick={() => {setTimeout(() => { dispatch(showPwaLoader(false))}, 3000);dispatch(showPwaLoader(true));dispatch(openAccountSidebar(false))}} href="/privacy">
              Privacy Policy
            </Link>
            . By signing up you agree to our{" "}
            <Link tabIndex={0} className="pwa-link-tag xx-small-xs small-sm x-small-md" onClick={() => {setTimeout(() => {dispatch(showPwaLoader(false))}, 3000);dispatch(showPwaLoader(true));dispatch(openAccountSidebar(false))}} href="/legal">
              Terms
            </Link>
            .
          </label>
        </div>
      </div>
      </div>
      {/* <button type="submit">Submit</button> */}
      <div className={`${isPWA && checkPwaGuest && wc_journey_step !== 6 ? styles.pwa_create_account:""}`}>
        <div className={`${styles.form_btn}`}>
          <button
            tabIndex={0}
            type="submit"
            className={`normal btn-primary ${alreadyAccount?styles.disabled:""} ${styles.btn_loading} ${
              loading ? "loading" : ""
            }`}
          >
            {/* css conditions to check user is in PWA and in a welcome journey step */}
            <div className={`${wishlist_cookie&&"ga_wishlist_create_account"} ${isPWA && wc_journey_step !== 6 ? "ga_pwa_create_account" : "ga_create_account"}`}>
            Create your account
            </div>
          </button>
        </div>
        { isPWA && wc_journey_step !== 6  && <div className={`${styles.guest_div}`}>
          <p className="x-small-xs" onClick={handleAsGuest}>
            <Link className="ga_pwa_guest underline" data-ga4="App: WJ - Create account > Continue as guest" href="/">
              Continue as guest
            </Link>
          </p>
        </div>}
      </div>
      {/* wc_journey_step is added to hide form assitance section in welcome journey for create account */}
      {wc_journey_step==6 && <div className={`${styles.form_assistance} ga-help ${isPWA ? "addBottomPadding" : ""}`}>
        <p className="small-xs normal-sm normal-md para-with-link">
          Need assistance? Contact us by{" "}
          <Link href={`mailto:${generalConstants.help_email}`} tabIndex={0}>
            <span className="ga-help">email</span>
          </Link>
        </p>
      </div>}
    </form>
  );
}
